"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontendConfiguration = void 0;
/// <reference types="node" />
class FrontendConfiguration {
    static environment() {
        if (FrontendConfiguration.appUrl().includes("localhost")) {
            return this.LOCAL;
        }
        else if (FrontendConfiguration.appUrl().includes("vacasastage.")) {
            return this.STAGING;
        }
        else if (FrontendConfiguration.appUrl().includes("vacasa.")) {
            return this.PRODUCTION;
        }
        return this.LOCAL;
    }
    static appUrl() {
        const { REACT_APP_APP_URL } = process.env;
        return REACT_APP_APP_URL;
    }
    static vacasaIdpDomain() {
        const { REACT_APP_VACASA_IDP_DOMAIN } = process.env;
        return REACT_APP_VACASA_IDP_DOMAIN;
    }
    static idpRedirectUri() {
        const { REACT_APP_IDP_REDIRECT_URI } = process.env;
        return REACT_APP_IDP_REDIRECT_URI;
    }
    static idpClientId() {
        const { REACT_APP_IDP_CLIENT_ID } = process.env;
        return REACT_APP_IDP_CLIENT_ID;
    }
    static adminConfig() {
        const { REACT_APP_PUBLIC_KEY_FROM_ADMIN, REACT_APP_ADMIN_URL } = process.env;
        return { publicKey: REACT_APP_PUBLIC_KEY_FROM_ADMIN, url: REACT_APP_ADMIN_URL };
    }
    static idpManagementServiceConfig() {
        return { url: process.env.REACT_APP_IDP_MNG_URL };
    }
}
exports.FrontendConfiguration = FrontendConfiguration;
FrontendConfiguration.LOCAL = "local";
FrontendConfiguration.STAGING = "stage";
FrontendConfiguration.PRODUCTION = "prod";
//# sourceMappingURL=frontend.configuration.js.map